"use client";

import Image from "next/image";
import "@/styles/page/lich-su/_hub-stats.scss";

type HubStatsCard = {
  id: number;
  number: string;
  description: string;
  variant: "gray" | "yellow" | "primary" | "black";
  hasImage?: boolean;
  imageSrc?: string;
  imageAlt?: string;
};

export type LichSuHubStatsProps = {
  title?: string;
  cards?: HubStatsCard[];
};

const DEFAULT_CARDS: HubStatsCard[] = [
  {
    id: 1,
    number: "50+",
    description: "Năm xây dựng và phát triển",
    variant: "gray",
  },
  {
    id: 2,
    number: "20.000+",
    description: "Sinh viên đang theo học ở các bậc đào tạo từ đại học, thạc sĩ, tiến sĩ",
    variant: "yellow",
    hasImage: true,
    imageSrc: "/assets/images/lichsu_img14.png",
    imageAlt: "",
  },
  {
    id: 3,
    number: "3",
    description: "Cơ sở đào tạo (02 tại Q1, 01 tại Thủ Đức)",
    variant: "primary",
  },
  {
    id: 4,
    number: "500+",
    description: "Cán bộ, giảng viên, nhân viên (62 GS, PGS, 208 Tiến sĩ, 238 Thạc sĩ)",
    variant: "primary",
    hasImage: true,
    imageSrc: "/assets/images/lichsu_img14.png",
    imageAlt: "",
  },
  {
    id: 5,
    number: "70.000+",
    description: "Cử nhân, thạc sĩ, tiến sĩ đã được HUB đào tạo",
    variant: "black",
  },
  {
    id: 6,
    number: "38 / 184",
    description: "Giáo sư, Phó Giáo sư / Tiến sĩ trong đội ngũ giảng viên cơ hữu",
    variant: "gray",
    hasImage: true,
    imageSrc: "/assets/images/lichsu_img14.png",
    imageAlt: "",
  },
];

const normalizeCards = (cards: HubStatsCard[] | undefined): HubStatsCard[] => {
  if (!Array.isArray(cards) || cards.length === 0) return DEFAULT_CARDS;
  return cards.map((card, index) => ({
    id: typeof card.id === "number" ? card.id : index + 1,
    number: typeof card.number === "string" ? card.number : "",
    description: typeof card.description === "string" ? card.description : "",
    variant: card.variant ?? "gray",
    hasImage: Boolean(card.hasImage),
    imageSrc: typeof card.imageSrc === "string" ? card.imageSrc : "/assets/images/lichsu_img14.png",
    imageAlt: typeof card.imageAlt === "string" ? card.imageAlt : "",
  }));
};

export default function LichSuHubStats({
  title = "HUB THEO SỐ LIỆU",
  cards,
}: LichSuHubStatsProps = {}) {
  const resolvedCards = normalizeCards(cards);

  return (
    <section className="hub-stats">
      <div className="container">
        <h2 className="hub-stats__title">{title}</h2>
        <div className="hub-stats__grid">
          {resolvedCards.map((card) => (
            <article
              key={card.id}
              className={`hub-stats__card hub-stats__card--${card.variant} hub-stats__card--${card.id}`}
            >
              {card.hasImage && card.imageSrc ? (
                <div className="hub-stats__image">
                  <Image
                    src={card.imageSrc}
                    alt={card.imageAlt ?? ""}
                    width={390}
                    height={160}
                    loading="lazy"
                  />
                </div>
              ) : null}
              <div className="hub-stats__content">
                <span className="hub-stats__number">{card.number}</span>
                <p className="hub-stats__description">{card.description}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

